import { GET_BUYERS, GET_BUYERS_ERROR, GET_BUYERS_SUCCESS } from './BuyersList.actions'

const buyersListState = {
  data: [],
  error: null,
  loading: false
}

/**
 * The buyers list's reducer.
 */
const buyersListReducer = (state = buyersListState, { payload, type }) => {
  switch (type) {
    case GET_BUYERS: {
      return { ...state, loading: true }
    }
    case GET_BUYERS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_BUYERS_SUCCESS: {
      return { ...state, data: payload.buyers, loading: false }
    }
    default: {
      return state
    }
  }
}

export default buyersListReducer
